<div class="calc-item" *ngIf="model" [class.selected]="selected">
  <div data-cy="result-query-text" class="query">
    {{ queryDisplayText }}
  </div>
  <div calcresult-cy="result-container" class="result-container">
    <div class="result">
      <div data-cy="result-text" class="text">
        {{ resultDisplayText }}
      </div>
      <div data-cy="result-disclaimer" class="disclaimer" *ngIf="model.resource.result.type === 'Currency'">
        {{ disclaimerLastUpdate | date: 'MMM d, h:mm a z' }}, Data provided by
        <span class="link" (click)="onDisclaimerLinkClick()">{{ disclaimerName }}</span>
      </div>
    </div>
    <div class="copy-command" data-cy="result-copy-container">
      <span data-cy="result-copy-span"
        >Press
        <u-icon data-cy="result-copy-icon" class="icon" [model]="{ type: 'font', value: 'icon-key-enter' }"></u-icon>
        to copy to clipboard</span
      >
    </div>
  </div>
</div>
